<modal-window [title]="title" [modal]="true" [show]="show">
                    <div class="vt-modal-body">
                        <p>{{message}}</p>
                    </div>
                    <div class="vt-modal-footer">
                        <button class="btn btn-lg btn-info btn-block" (click)="confirm(true)">Yes</button>
                        <button class="btn btn-lg btn-danger btn-block" (click)="confirm(false)">No</button>
                    </div>
                </modal-window>